<template>
	<div>
		<header class="header">
			<div
				class="header_wrapper"
				:style="'background-image:url(//sk.skolkovo.ru/img/2d818076-e22b-4e17-b362-1fc3d14e2894/404.jpg?fm=jpg&q=80&fit=crop&crop=2560%2C948%2C0%2C0&w=2560&h=948);'"
			>
				<top-menu-new />
				<div class="container mt-5 pt-lg-5">
					<div class="header_main">
						<div class="title_block">
							<h1>{{ error.statusCode || 500 }}</h1>
							<div class="subtitle">
								Ошибка на странице
							</div>
							<p>
								{{ error }}
							</p>
							<nuxt-link :to="{ name: 'index' }" class="btn btn-primary">
								На главную
							</nuxt-link>
						</div>
					</div>
				</div>
			</div>
		</header>
		<main-footer />
	</div>
</template>

<script>
import MainFooter from '~/components/layouts/footers/MainFooter.vue';
import IssueMenu from '~/components/layouts/_partials/IssueMenu.vue';
import TopMenuNew from '~/components/layouts/_partials/TopMenuNew.vue';

export default {
	components: {
		MainFooter,
		IssueMenu,
		TopMenuNew,
	},
	props: { error: { type: Object, required: true } },
	computed: {
		message() {
			if (Number.isInteger(this.error.statusCode)) {
				return this.error.message;
			}
			return this.error;
		},
	},
	head() {
		return {
			title: '500',
		};
	},
};
</script>

<style lang="scss" scoped>
	@import '~/assets/styles/components/layouts/issue-header-panel';
</style>
